import React, { useCallback } from 'react';
import toast from 'react-hot-toast';
import { Image } from 'semantic-ui-react';
import ImgClose from 'Assets/images/pages/web-chat/close.svg';

import ControlButton from '../VideoControls/ControlButton/ControlButton';

function useShowToast() {
  const showToast = useCallback((icon, message, isError) => {
    toast(
      t => (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
          <div>
            <ControlButton icon={icon} gray showError={isError} size={48} />
          </div>
          {message}
          <Image src={ImgClose} onClick={() => toast.dismiss(t.id)} />
        </div>
      ),
      {
        id: `device_not_found`,
        duration: 10000,
        position: 'top-center',
        hideProgressBar: true,
        style: {
          zIndex: 900000,
          backgroundColor: '#1B1E21',
          color: '#fff',
        },
      },
    );
  }, []);

  return { showToast };
}

export default useShowToast;
